export default {"src":"/_next/static/media/dapper-iso-logo.257e84ac.svg","height":404,"width":395,"blurWidth":0,"blurHeight":0};